import breakpoints from "@shared/theme/props/breakpoints";
import Box from "../Box/Box.web";
import { PageMaxWidthSharedProps } from "./PageMaxWidth.props";

const { xl } = breakpoints;

const PageMaxWidth = ({ children, ...props }: PageMaxWidthSharedProps) => {
  return (
    <Box
      width="100%"
      margin="0 auto"
      maxW={`${xl + 80}px`}
      padding={{ base: "0px 20px", sm: "0px 40px" }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default PageMaxWidth;
